
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';
import 'leaflet/dist/leaflet.css';

Vue.config.productionTip = false;
Vue.use(VueScrollTo);

//axios.defaults.baseURL = "http://127.0.0.1:8000/"; // Desarrollo
axios.defaults.baseURL = "https://ecocontrol.eastus.cloudapp.azure.com/api/"; // Producción (HTTPS)

//ESTO ME PERMITE ENVIAR LAS COOKIES EN EL ENCABEZADO
axios.defaults.withCredentials = true;


// Configuración del token CSRF
async function obtenerTokenCSRF() {
  try {
      const response = await axios.get('/token');
      return response.data;
  } catch (error) {
      console.error('Error al obtener el token CSRF:', error); 
      return null;
  }
}

//ESTO ME PERMITE ENVIAR EL TOKEN EN EL ENCABEZADO
axios.defaults.headers.common['X-CSRF-TOKEN'] = await obtenerTokenCSRF();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
